import { Component, Input, OnInit } from '@angular/core';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { CardStatusType, baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Subject, takeUntil, tap } from 'rxjs';
import { FreezeCard, UnFreezeCard } from '../../../..//lib/actions/card-management.action';
import { CardState } from '../../../../lib/state/card.state';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-freeze-card',
  templateUrl: './freeze-card.component.html',
  styleUrls: ['./freeze-card.component.scss'],
})
export class FreezeCardComponent implements OnInit {
  @AutoDestroy destroy$ = new Subject<void>();
  @Input() isSeparateZone: boolean;
  @Input() isFreezeCard: boolean;
  @Input() isWorkflow: boolean;
  @Input() borderStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  @Input() contentStyle: baseCssConfigStyle;
  @Input() cardLabel: string;

  isWidgetDisabled: boolean;

  constructor(private store: Store) {}

  private currentAccountId = () => this.store.selectSnapshot(AccountState.getCurrentAccountId);

  private currentCardId = () => this.store.selectSnapshot(CardState.getCurrentCardId);

  ngOnInit(): void {
    this.store
      .select(CardState.getCurrentCardDetail)
      .pipe(
        takeUntil(this.destroy$),
        tap((response) => {
          if (response) {
            this.isWidgetDisabled = response.status !== CardStatusType.ACTIVE;
          } else {
            this.isWidgetDisabled = true;
          }
        }),
      )
      .subscribe();
  }

  onFreezeCard(): void {
    if (this.isFreezeCard) {
      this.store.dispatch(
        new UnFreezeCard({
          accountId: this.currentAccountId(),
          cardId: this.currentCardId(),
        }),
      );
    } else {
      this.store.dispatch(
        new FreezeCard({
          accountId: this.currentAccountId(),
          cardId: this.currentCardId(),
        }),
      );
    }
    this.isFreezeCard = !this.isFreezeCard;
    this.onSetCardLabel();
  }

  private onSetCardLabel(): void {
    this.cardLabel = this.isFreezeCard ? 'Unfreeze' : 'Freeze';
  }
}
